import { useTranslation } from 'react-i18next';
import { MetricCard, MetricValue, EmptyState, ProfileIconsContainer } from './index.styles';
import ProfileIcons from '../../../ProfileIcons';
import ChangeComponent from '../../../ChangeComponent';
import { formatCompact } from '../../../../helpers';

export const MetricCardRenderer = ({ data, selectedProfiles, supportedPlatforms }: DynamicModuleBuilderProps) => {
  const { t } = useTranslation('reports');

  if (!data || data.chartType !== 'MetricCard') {
    return <EmptyState>{t('new_reports_no_engagement_data')}</EmptyState>;
  }

  const { metrics, data: metricData } = data;

  if (!metrics || metrics.length === 0) {
    return <EmptyState>{t('new_reports_no_engagement_data')}</EmptyState>;
  }

  const { current, previous, difference, percentage } = metricData;
  const metric = metrics[0];
  const isPercentageType = metric.type === 'percentage';

  const formattedValue = isPercentageType ? `${(current * 100).toFixed(1)}%` : formatCompact(current);

  const hasPrevious = previous !== null && previous !== undefined && difference !== null && difference !== undefined;
  const isPositive = (difference ?? 0) >= 0;

  // signed, compact-formatted: +1.2K / -80
  const formattedDiff = `${isPositive ? '+' : '−'}${formatCompact(Math.abs(difference ?? 0))}`;

  // signed percentage, trimming a trailing .00 so 19.00% → 19%: +19.22% / -2%
  const pctAbs = Math.abs(percentage ?? 0);
  const pctStr = Number.isInteger(pctAbs) ? String(pctAbs) : pctAbs.toFixed(2).replace(/\.?0+$/, '');
  const formattedPct = `${isPositive ? '+' : '−'}${pctStr}%`;

  return (
    <MetricCard>
      <MetricValue>{formattedValue}</MetricValue>
      {hasPrevious && (
        <ChangeComponent
          isPositive={isPositive}
          formattedDiff={formattedDiff}
          formattedPct={formattedPct}
        />
      )}
      <ProfileIconsContainer>
        <ProfileIcons
          selectedProfiles={selectedProfiles}
          supportedPlatforms={supportedPlatforms}
        />
      </ProfileIconsContainer>
    </MetricCard>
  );
};
